export default "__VITE_ASSET__BhpLrlZ8__"